import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { createRoot } from "react-dom/client";

import App from './App';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');

if (!container) throw new Error("Unable to mount the app: no #root element in the document");

const root = createRoot(container);

root.render(
    <HelmetProvider>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </HelmetProvider>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();
